<template>
  <!-- wrapper(s) -->
  <div class="wrapper">
    <Header class="header" :val="headerTitle" :type="'share'" :shareParam="shareParam"></Header>
    <div class="container">
      <!-- content(s) -->
      <div id="content">
        <div class="rouletArea rl">
          <!-- 룰렛 날짜 추가 html -->
          <!-- 달(월)이 바뀔때 마다 해당 달(월)의 1일 과 마지막 일 노출 -->
          <div class="rouletTime">
            <span class="rouletTime_txt1">이벤트 기간</span>
            <span class="rouletTime_txt2">{{ date[0] }} ~ {{ date[1] }}</span>
          </div>
          <div class="rouletWrap" :class="{ end1: endType == 1, end2: endType == 2 }">
            <!-- 참여완료 : end1 / 교환완료 : end2 -->
            <div class="rl_bg"><img src="https://www.welrixrental.co.kr/img_1/welmall_comm_img/1631671553937_bg_roulette_back.png" alt="" /></div>
            <div class="roulet">
              <ul>
                <li>
                  <span>
                    <em>1</em>
                    포인트
                  </span>
                </li>
                <li>
                  <span>
                    <em>2</em>
                    포인트
                  </span>
                </li>
                <li>
                  <span>
                    <em>3</em>
                    포인트
                  </span>
                </li>
                <li>
                  <span>
                    <em>4</em>
                    포인트
                  </span>
                </li>
                <li>
                  <span>
                    <em>5</em>
                    포인트
                  </span>
                </li>
                <li>
                  <span>
                    <em>꽝</em>
                    아쉽네요..
                  </span>
                </li>
              </ul>
              <span class="line">
                <span></span>
                <span></span>
                <span></span>
                <span></span>
                <span></span>
                <span></span>
              </span>
            </div>
            <div class="point"></div>
            <div class="imgMsg"></div>
            <button type="button" class="btnStart spin" @click="getRuletPoint"><span class="blind">시작</span></button>
          </div>
          <div class="result">
            <p class="txtRst">
              <span>내가 모은 룰렛 포인트 :</span>
              <em>
                <i>{{ myPoint ? myPoint : 0 }}</i>
                P
              </em>
            </p>
            <p class="boxRst">
              참여횟수 :
              <span>{{ myRuletCnt ? myRuletCnt : 0 }}</span>
              /
              <span>2</span>
            </p>
          </div>
        </div>

        <section>
          <div class="titArea">
            <h2 class="titH3 normal">이용 방법</h2>
          </div>
          <ul class="txtList_numS">
            <li>매일 2회 룰렛을 돌린다.</li>
            <li>원하는 쿠폰 1종을 교환한다.</li>
          </ul>
        </section>

        <section class="hr">
          <div class="titArea">
            <h2 class="titH3 normal">쿠폰 교환</h2>
          </div>
          <p class="txt">룰렛 포인트로 원하는 쿠폰 1종을 교환해보세요.</p>

          <div class="titArea mb0">
            <h3 class="titH4 normal">신규 계약용</h3>
          </div>
          <ul class="couponList ev">
            <li v-for="(nc, key) in newCoupList" :key="key">
              <button
                type="button"
                :disabled="nc.isRuletApplyYn == 'Y' || nc.ruletPt > myPoint ? true : false || !coupChk"
                @click="newDownCoupon(nc.cponId, nc.ruletPt)"
              >
                <span class="tit">{{ nc.titl }}</span>
                <p class="txt">
                  <em>{{ nc.discAmt | currency }}</em>
                  원 할인
                </p>
                <div class="point">
                  <em>{{ nc.ruletPt }}P</em>
                  교환하기
                </div>
              </button>
            </li>
          </ul>

          <div class="titArea mb0">
            <h3 class="titH4 normal">기존 계약용</h3>
          </div>
          <ul class="couponList ev">
            <li v-for="(old, key) in oldCoupList" :key="key">
              <button
                type="button"
                :disabled="old.isRuletApplyYn == 'Y' || old.ruletPt > myPoint ? true : false || !coupChk"
                @click="downCouponProc(old.cponId, old.ruletPt)"
              >
                <span class="tit">{{ old.titl }}</span>
                <p class="txt">
                  <em>{{ old.discAmt | currency }}</em>
                  원 할인
                </p>
                <div class="point">
                  <em>{{ old.ruletPt }}P</em>
                  교환하기
                </div>
              </button>
            </li>
          </ul>
        </section>
        <section class="full couponNotice">
          <h4 class="txtS pointC4">유의사항</h4>
          <ul class="txtList_dash">
            <li>교환은 월 1회 가능하며, 룰렛 포인트 이월 불가</li>
            <li>신규 할인쿠폰은 발급일로부터 30일 유효</li>
            <li>기존 계약용 할인쿠폰 교환 시 자동 사용 처리되며 할인은 다음달 렌탈료에 자동 적용</li>
            <li>쿠폰 적용시 익월 렌탈료가 쿠폰보다 적어도 적용 가능하며 남은 쿠폰금액 차액은 이월되지 않고 소멸됩니다.</li>
          </ul>
        </section>
      </div>
      <!-- content(e) -->
    </div>
    <!-- container(e) -->
    <footer class="footer"></footer>
    <MessagePop v-if="messagePop" @close="messagePop = false">
      <p v-html="msg"></p>
    </MessagePop>
    <ConfirmPop @cancel="cancel" @confirm="confirm" v-if="confirmPop" @close="confirmPop = false">
      <p v-html="msg"></p>
    </ConfirmPop>

    <ConfirmPop @cancel="cancel" @confirm="loginConfirm" v-if="loginConfirmPop" @close="loginConfirmPop = false">
      <p v-html="msg"></p>
    </ConfirmPop>
    <!-- popup (s) -->
    <div class="popWrap nowOpen" v-show="couponPop">
      <div class="popup">
        <div class="popContain">
          <div class="popCont" tabindex="-1" role="dialog">
            <div class="popHead">
              <h1 class="titH1">쿠폰 적용 상품 선택</h1>
            </div>
            <div class="popBody">
              <div class="popInner" v-show="myOrderList.length == 0">
                <section>
                  <div class="resultMsg txtOnly">
                    <p class="copy">적용 가능 상품이 없습니다.</p>
                  </div>
                </section>
              </div>
              <div class="btnArea sticky" v-show="myOrderList.length == 0">
                <button type="button" class="btn_s" @click="closeCouponPop">닫기</button>
              </div>

              <div class="popInner" v-show="myOrderList.length > 0">
                <section>
                  <ul class="prdList line">
                    <li v-for="(list, key) in myOrderList" :key="key">
                      <span class="singleIpt">
                        <input type="checkbox" class="ipt" name="mod1" :value="list.orderId" :id="'mod1_' + key" v-model="confirmCoupOrNo" />
                        <label :for="'mod1_' + key">
                          <span class="blind">해당열 상품</span>
                          선택
                        </label>
                      </span>
                      <span class="rInfo">
                        (주문번호 :
                        <i>{{ list.orderId }}</i>
                        )
                      </span>
                      <div class="block">
                        <div class="prdItem xs">
                          <div class="imgArea">
                            <span class="img"><img :src="list.thumbnail" :alt="list.productName" /></span>
                          </div>
                          <div class="infoArea">
                            <div class="tit">
                              <span>{{ list.productName }}</span>
                            </div>
                            <div class="txtItem">
                              <span>GRA841SR</span>
                            </div>
                            <div class="price">
                              <span class="money">
                                월 렌탈료
                                <em>{{ list.rentalAmount | currency }}</em>
                                원
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </li>
                  </ul>
                </section>
              </div>
            </div>

            <div class="btnArea sticky two half" v-show="myOrderList.length > 0">
              <button type="button" class="btn_g" @click="closeCouponPop">취소</button>
              <button type="button" class="btn_p" @click="newDownCouponProc">확인</button>
            </div>

            <button type="button" class="btnIco_close" @click="closeCouponPop"><span>팝업 닫기</span></button>
          </div>
        </div>
      </div>
      <MessagePop v-if="messagePop2" @close="close">
        <p v-html="msg"></p>
      </MessagePop>
    </div>
    <!-- popup (e) -->
  </div>
  <!-- wrapper(e) -->
</template>
<script>
//import * as customjs from '@/../../static/js/m.front.js';
import QuickMenu from '@/views/app/comm/QuickMenu';
import JwtService from '@/common/jwt.service';
import { gsap } from 'gsap';
import ApiService from '@/common/api.service';
import MessagePop from '@/components/popup/MessagePop';
import $ from 'jquery';
import ConfirmPop from '@/components/popup/ConfirmPop';

export default {
  name: 'dailyEvent',
  components: {
    QuickMenu,
    MessagePop,
    ConfirmPop,
  },
  data() {
    return {
      headerTitle: '출석이벤트',

      chance: 1,
      myRuletCnt: 0,
      choiceValue: 0,
      myPoint: 0,
      IMG_DOMAIN: '',
      load: 0, // 0일때 돌릴수 있음
      ruletCheck: true,
      userInfo: [],
      newCoupList: [],
      oldCoupList: [],
      endType: 0, //1: 당일 종료 2: 월종료 포인트 소모완료
      dlyYn: 'N', // Y: 연체 N 미연체
      coupChk: true,
      myOrderList: [], //내 렌탈 리스트

      msg: null, // 팝업 메세지
      messagePop: false, // 메세지 팝업
      messagePop2: false, // 팝업 안 메시지 팝업

      couponPop: false,
      confirmPop: false,
      loginConfirmPop: false,

      confirmReturn: false, // 컨펌창 이후 선택
      confirmType: 1, // 쿠폰 타입 1 new 2 old
      confirmCoupId: '', // 선택된 쿠폰 id
      confirmCoupOrNo: [], // 선택된 order no

      date: this.getDate(),

      shareParam: {
        img: '',
        title: '',
        index: 'dailyEvent',
      },
    };
  },
  mounted() {
    if (JwtService.getUserInfo() != null) {
      this.getUserRuletInfo();
    } else {
      this.getGuestRuletInfo();
    }

    let maxH = $(window).height() * 0.8 - $('.popHead').outerHeight() - 20;
    if ($('.popCont').hasClass('hasBtn')) {
      maxH = maxH - $('.btnArea.sticky').outerHeight() + 20;
    }
    $('.popCont').addClass('hasBtn');
    $('.popBody').css('max-height', maxH);

    // 공유하기용 공통 이미지 및 문구 가져오기
    ApiService.service('GET', '/resource/commonImage')
      .then(({ data }) => {
        const array = data.result;
        for (let i = 0; i < array.length; i++) {
          if (array[i].imgId == 109) {
            this.shareParam.img = array[i].imgPath;
            this.shareParam.title = array[i].imgDesc;
          }
        }
      })
      .catch(({ response }) => {
        console.log(response);
      });
  },
  watch: {
    confirmCoupOrNo() {
      console.log(this.confirmCoupOrNo);
      if (this.confirmCoupOrNo.length > 1) {
        this.confirmCoupOrNo.shift();
      }
    },
  },
  methods: {
    check() {
      console.log(this.confirmCoupOrNo);
    },
    start(choiceValue) {
      if (this.load == 1) return false;
      this.load = 1;
      let vue = this;
      gsap.to('.roulet', {
        duration: 4,
        ease: 'slow.out',
        rotation: this.chance * 3600 + choiceValue * 60,
        onComplete() {
          console.log('done');
          setTimeout(function () {
            vue.load = 0;
            vue.ruletCheck = true;
          }, 400);
          vue.getUserRuletInfo();
        },
      });
      this.chance++;
    },
    getGuestRuletInfo() {
      ApiService.service('GET', 'service/nonmember/getUserRuletInfo')
        .then(({ data }) => {
          //console.log(data);
          this.newCoupList = data.result.cponUseTpNewList;
          this.oldCoupList = data.result.cponUseTpUsedList;
          this.userInfo = data.result.custRuletInfo;
          if (data.result.custRuletInfo == '') return false;
          if (this.userInfo.ruletEndYn == 'Y') {
            this.endType = 2;
          } else if (this.userInfo.dtEndYn == 'Y') {
            this.endType = 1;
          }

          this.myPoint = this.userInfo.totBalPnt;
          this.myRuletCnt = this.userInfo.dtCnt;
        })
        .catch(({ response }) => {
          console.log(response);
        });
    },
    getUserRuletInfo() {
      ApiService.service('GET', 'service/auth/getUserRuletInfo')
        .then(({ data }) => {
          console.log(data);
          this.userInfo = data.result.custRuletInfo;
          if (data.result.custRuletInfo == '') return false;
          if (this.userInfo.ruletEndYn == 'Y') {
            this.endType = 2;
          } else if (this.userInfo.dtEndYn == 'Y') {
            this.endType = 1;
          }

          this.newCoupList = data.result.cponUseTpNewList;
          this.oldCoupList = data.result.cponUseTpUsedList;

          for (let value of this.newCoupList) {
            if (value.isRuletApplyYn == 'Y') {
              this.coupChk = false;
            }
          }
          for (let value of this.oldCoupList) {
            if (value.isRuletApplyYn == 'Y') {
              this.coupChk = false;
            }
          }
          this.myPoint = this.userInfo.totBalPnt;
          this.myRuletCnt = this.userInfo.dtCnt;
        })
        .catch(({ response }) => {
          console.log(response);
        });

      ApiService.service('GET', 'service/auth/ruletMyRentalList')
        .then(({ data }) => {
          console.log(data);
          this.myOrderList = data.result.myOrderList;
          this.dlyYn = data.result.dlyYn;
        })
        .catch(({ response }) => {
          console.log(response);
        });
    },
    getRuletPoint() {
      //로그인 체크
      if (JwtService.getUserInfo() == null) {
        this.msg = '로그인 후 이벤트 참여가 가능합니다.<br>로그인 하시겠습니까?';
        this.loginConfirmPop = true;
        return;
      }
      //console.log(this.ruletCheck);
      if (!this.ruletCheck) return false;
      this.ruletCheck = false;
      ApiService.service('POST', 'service/auth/rulet', {
        request: {
          userId: JwtService.getUserInfo().userId,
        },
        serviceType: 'app',
      })
        .then(({ data }) => {
          console.log(data);
          let p = { 0: 1, 1: 0, 5: 2, 4: 3, 3: 4, 2: 5 };
          if (data.isSucceed) {
            this.start(p[data.result.ruletPnt]);
          } else {
            this.msg = data.error;
            this.messagePop = true;
          }
        })
        .catch(({ response }) => {
          console.log(response);
        });
    },
    downCouponProc(cid, cpoint) {
      if (JwtService.getUserInfo() == null) {
        this.msg = '로그인 후 이벤트 참여가 가능합니다.<br>로그인 하시겠습니까?';
        this.loginConfirmPop = true;
        return;
      }
      if (this.dlyYn == 'Y') {
        this.msg = '연체중입니다.<br>연체 해지 후 교환해주세요.';
        this.messagePop = true;
        return false;
      }
      if (this.myPoint < cpoint) {
        this.msg = '포인트가 부족합니다.';
        this.messagePop = true;
        return false;
      }
      this.confirmCoupOrNo = [];
      this.couponPop = true;
      $('body').addClass('popOn');

      this.confirmType = 2;
      this.confirmCoupId = cid;
    },
    closeCouponPop() {
      this.couponPop = false;
      $('body').removeClass('popOn');
    },
    cancel() {
      this.confirmReturn = false;
      this.confirmPop = false;
      this.loginConfirmPop = false;
    },
    confirm() {
      this.confirmReturn = true;
      this.confirmPop = false;
      this.newDownCouponProc();
    },
    loginConfirm() {
      this.$router.push({ name: 'login', params: { redirect: this.$route.name } });
    },
    newDownCoupon(cid, cpoint) {
      if (JwtService.getUserInfo() == null) {
        this.msg = '로그인 후 이벤트 참여가 가능합니다.<br>로그인 하시겠습니까?';
        this.loginConfirmPop = true;
        return;
      }
      if (this.dlyYn == 'Y') {
        this.msg = '연체중입니다.<br>연체 해지 후 교환해주세요.';
        this.messagePop = true;
        return false;
      }
      if (this.myPoint < cpoint) {
        this.msg = '포인트가 부족합니다.';
        this.messagePop = true;
        return false;
      }
      this.confirmType = 1;
      this.confirmCoupId = cid;

      this.msg = '교환 하시겠습니까?';
      this.confirmPop = true;
    },
    close() {
      this.messagePop = false;
      this.messagePop2 = false;
      if (this.confirmCoupOrNo.length > 0) {
        $('body').removeClass('popOn');
        this.couponPop = false;
      }
    },
    newDownCouponProc() {
      if (this.confirmType == 1) {
        this.confirmCoupOrNo = [];
      } else {
        if (this.confirmCoupOrNo.length < 1) {
          this.msg = '상품을 선택해주세요.';
          this.messagePop2 = true;
          return false;
        }
      }

      ApiService.service('POST', 'service/auth/exchgRuletPnt', {
        request: {
          cponId: this.confirmCoupId,
          orderId: this.confirmCoupOrNo.length == 0 ? null : this.confirmCoupOrNo[0],
          userId: JwtService.getUserInfo().userId,
        },
        serviceType: 'app',
      })
        .then(({ data }) => {
          console.log(data);
          if (data.isSucceed) {
            if (this.confirmType == 1) {
              this.msg = '쿠폰 교환 완료<br>쿠폰함에서 확인하세요.';
              this.messagePop = true;
            } else {
              this.msg = '쿠폰은 자동 사용 처리 완료되며<br>차월 청구 렌탈료에 적용됩니다.';
              this.messagePop2 = true;
            }
            this.getUserRuletInfo();
          } else {
            this.msg = data.error;
            if (this.confirmType == 1) {
              this.messagePop = true;
            } else {
              this.messagePop2 = true;
            }
          }
        })
        .catch(({ response }) => {
          console.log(response);
        });
    },
    getDate() {
      let value = [];
      const week = ['일', '월', '화', '수', '목', '금', '토'];

      let now = new Date();
      let nowYear = now.getYear();
      let firstDate, lastDate, firstWeek, lastWeek;

      let formatDate = function (date) {
        let myMonth = date.getMonth() + 1;
        let myWeekDay = date.getDate();

        let addZero = function (num) {
          if (num < 10) {
            num = '0' + num;
          } else {
            num = num + '';
          }
          return num;
        };
        let md = addZero(myMonth) + '.' + addZero(myWeekDay);

        return md;
      };

      firstDate = new Date(now.getYear(), now.getMonth(), 1);
      lastDate = new Date(now.getYear(), now.getMonth() + 1, 0);
      nowYear += nowYear < 2000 ? 1900 : 0;

      firstDate = `${nowYear}.${formatDate(firstDate)}`;
      lastDate = `${nowYear}.${formatDate(lastDate)}`;

      // firstWeek = week[new Date(firstDate).getDay()];
      // lastWeek = week[new Date(lastDate).getDay()];

      // value.push(`${firstDate}(${firstWeek})`);
      // value.push(`${lastDate}(${lastWeek})`);
      value.push(firstDate);
      value.push(lastDate);
      return value;
    },
  },
};
</script>
